import { TableCell, TableRow } from "@material-ui/core"
import React, { Fragment } from "react"

export default function MacTable({ macCommands }) {
  let checkPayload = (payload, value) => {
    if (value === "") {
      return
    }
    let typeOf = typeof value
    if (typeOf === "number" || typeOf === "boolean" || typeOf === "string") {
      let val
      if (typeOf === "boolean") {
        val = value ? 1 : 0
      } else {
        val = value
      }

      return (
        <TableRow key={"id1-" + Math.random()} hover style={{ cursor: "pointer" }}>
          <TableCell className={"cell pd"} style={{ paddingLeft: "15px" }}>
            {payload}
          </TableCell>
          <TableCell className={"cell pd"}> {val} </TableCell>
        </TableRow>
      )
    } else if (typeOf === "object") {
      if (Array.isArray(value)) {
        return (
          <TableRow key={"id2-" + Math.random()} hover style={{ cursor: "pointer" }}>
            <TableCell className={"cell pd"} style={{ paddingLeft: "15px" }}>
              {payload}
            </TableCell>
            {payload === "chMask" && <TableCell className={"cell pd"}>[{value.map((item, index) => (item ? 1 : 0)).toString()}]</TableCell>}
            {payload === "Channels" && (
              <TableCell className={"cell pd"}>
                {value.map((item, index) => (
                  <p key={index} style={{ margin: 0 }}>
                    {index}: {item}
                  </p>
                ))}
              </TableCell>
            )}
          </TableRow>
        )
      } else {
        return Object.keys(value).map((v, index) => {
          return (
            <TableRow key={"id3-" + index} hover style={{ cursor: "pointer" }}>
              <TableCell className={"cell pd"} style={{ paddingLeft: "15px" }}>
                {v}
              </TableCell>
              <TableCell className={"cell pd"}> {value[v]}</TableCell>
            </TableRow>
          )
        })
      }
    }
  }

  return (
    <>
      <TableRow key={"id3-" + Math.random()} hover style={{ cursor: "pointer" }}>
        <TableCell colSpan={2} />
      </TableRow>

      {macCommands.map((mac, index) => {
        return (
          <Fragment key={index}>
            <TableRow key={index} hover style={{ cursor: "pointer" }}>
              <TableCell className={"cell pd"}>
                <span><b>MACcommand:</b></span>
              </TableCell>
              <TableCell className={"cell pd"}>{mac.cid.replace("Req", "").replace("Ans", "")}</TableCell>
            </TableRow>
            {mac.payload &&
              Object.keys(mac.payload).map((payload, c) => {
                return checkPayload(payload, mac.payload[payload])
              })}
            <TableRow hover style={{ cursor: "pointer" }}>
              <TableCell colSpan={2} />
            </TableRow>
          </Fragment>
        )
      })}
    </>
  )
}
